<template>
  <div class="third">
    <div class="third-formOne adhibition">
      <div class="formOne-btn">
        <div class="btn-left">
          <!-- <span class="left-back-icon" @click="goBack">
            <i class="el-icon-arrow-left"></i>
            <span class="left-back-title">返回</span>
          </span>
          <span class="left-back-shu">
            <span class="left-back-shu-content"></span>
          </span>-->
          <span class="left-back-content">个人中心管理</span>
          <!-- <span v-if="IDlist !== ''" class="left-back-content">编辑班级信息</span> -->
        </div>
        <div class="btn-right">
          <el-button
            class="btn-two"
            type="primary"
            v-el-disabel-repeat-click
            @click="updateFN"
          >保存</el-button>
          <el-button  class="btn-two" type="default" @click="Reset">重置</el-button>
        </div>
      </div>
      <el-form :model="formList" ref="formList"  :rules="rules" style="width:60%;float:left" label-width="86px"
        @validate="validateValue"
        :show-message="false"
      >
        <div class="formOne-forms">
          <div  class="forms-one" style="margin-top: 57px;">
            <div class="one-title">
              <div class="title-left">
                <span class="left-icon">
                  <i class="el-icon-s-operation"></i>
                </span>
                <span class="left-content palTel">系统访问连接</span>
                <span class="left-content palText">如系统为本地认证则不用填写</span>
              </div>
            </div>
            <div class="one-list myform-list">
              <el-form-item label="个人信息" prop="userInfo">
                <el-input
                  class="list-input myInput" 
                  :maxlength="1000" 
                  v-model="formList.userInfo"
                  placeholder="请完整输入http(s)访问连接">
                  </el-input>
              </el-form-item>
              <!-- <el-form-item label="账号安全" prop="accountSecurity">
                <el-input
                  class="list-input myInput"
                  :maxlength="1000"
                  v-model="formList.accountSecurity"
                  placeholder="请完整输入http(s)访问连接"
                ></el-input>
              </el-form-item> -->
              <el-form-item label="紧急联系人" prop="emergencyContact">
                <el-input
                  class="list-input myInput"
                  :maxlength="1000"
                  v-model="formList.emergencyContact"
                  placeholder="请完整输入http(s)访问连接"
                ></el-input>
              </el-form-item>
              <el-form-item label="登录日志" prop="loginLog">
                <el-input
                  class="list-input myInput"
                  :maxlength="1000"
                  v-model="formList.loginLog"
                  placeholder="请输入访问连接"
                ></el-input>
              </el-form-item>
               <el-form-item label="访问提示语">
                <el-input
                  type="textarea"
                  :rows="4"
                  class="list-input myInput"
                  :maxlength="200"
                  v-model="formList.accessTipsWords"
                  placeholder="请输入第三方访问提示语"
                ></el-input>
              </el-form-item>
            </div>
          </div>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import {
  detail,
  update
} from "@/store/management/Myconfig"; //我的
export default {
  name: "formSeven",
  props: ["IDlist"],
  data() {
    return{
      formList:{
        userInfo: "",
        accountSecurity: "",
        emergencyContact: "",
        loginLog: "",
      },//数据表
      errorMsg_1:"",
      rules: {
        userInfo: [
          { type: "string", pattern: /^http[s]?:\/\/.*/, message:"请完整输入http(s)", trigger: blur}
        ],
        accountSecurity: [
          { type: "string", pattern: /^http[s]?:\/\/.*/, message:"请完整输入http(s)", trigger: blur}
        ],
        emergencyContact: [
          { type: "string", pattern: /^http[s]?:\/\/.*/, message:"请完整输入http(s)", trigger: blur}
        ],
        loginLog: [
          { type: "string", pattern: /^http[s]?:\/\/.*/, message:"请完整输入http(s)", trigger: blur}
        ]
      },
      countNum: 1,
    }
  },
  created() {
   this.detailFN()
  },
  methods: {
    validateValue (prop, msgStatus, validateMessage) {
      if (!this.countNum && !msgStatus) {
        this.countNum += 1;
        if (validateMessage) {
          this.$message.error(validateMessage);
        }
      }
    },
    //获取系统访问链接
    detailFN(){
      try{
        detail().then(res=>{
          const data=res.data
          // console.log(data)
          if(data.status===1000){
            this.formList=data.result
          }
        })
      }catch(err){
        console.log(err)
      }
    },
    //重置
    Reset(){
      this.detailFN();
    },
    //保存
    updateFN(){
      this.countNum = 0;
      this.$nextTick(() => {
        this.$refs.formList.validate(valid => {
          if (valid) {
            try{
              const params=this.formList
              update(params).then(res=>{
                const data=res.data
                if(data.status===1000){
                  this.$message.success("操作成功")
                  // this.errorMsg_1="报错"
                }else{
                  this.$message.error(data.msg)
                }
              })
            }catch(err){
              console.log(err)
            }
          } else {
            return false;
          }
        });
      });
    }
  }
};
</script>

<style lang="scss">
.phon-right{
  position: relative;
  // border:1px solid red;
  width: 40%;
  display: inline-block;
  // height:calc(100vh - 102px);
  height: 100%;
  border-left: 1px solid #dcdee2;
  img{
    // border: 1px solid red;
    width: 389px;
    height: 669px;
    position: absolute;
    left: 0;
    right: 0;
    margin: auto;

  }
}
.myInput{
  width: 546px!important;
}
.palTel{
  font-size: 14px!important
}
.palText{
  color: rgba(155, 155, 155, 1)!important;
  padding-left:13px;
  font-size: 12px;
  font-weight: 400!important;
}
.myform-list{
  .el-form-item{
    margin-bottom: 10px!important
  }
  textarea{
    resize:none;
 }
}
</style>
